import { equalPrimitiveArrays } from './array.js';

var equalFlatObjects = function equalFlatObjects(a, b) {
  if (a === b) {
    return true;
  }
  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  for (var _i = 0, _Object$keys = Object.keys(a); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var aVal = a[key];
    var bVal = b[key];
    if (isPrimitiveArray(aVal) && isPrimitiveArray(bVal)) {
      if (!equalPrimitiveArrays(aVal, bVal)) {
        return false;
      }
    } else {
      if (aVal !== bVal) {
        return false;
      }
    }
  }
  return true;
};
var removeKeysFromObj = function removeKeysFromObj(obj, targetKeys) {
  var newObj = {};
  for (var _i2 = 0, _Object$keys2 = Object.keys(obj); _i2 < _Object$keys2.length; _i2++) {
    var unit = _Object$keys2[_i2];
    if (!targetKeys.includes(unit)) {
      newObj[unit] = obj[unit];
    }
  }
  return newObj;
};
var hasOwnProp = function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};
function isPrimitiveArray(value) {
  return Array.isArray(value);
}

export { equalFlatObjects, hasOwnProp, removeKeysFromObj };
